import React from 'react';

import {
  NumberInput,
  NumberInputField,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInputStepper,
} from '@chakra-ui/react';

export default function AbsoluteIntInput({
  numberVal,
  setNumberVal,
  minVal = Number.MIN_SAFE_INTEGER,
  maxVal = Number.MAX_SAFE_INTEGER,
}: {
  numberVal: number;
  setNumberVal: (newVal: number) => void;
  minVal?: number;
  maxVal?: number;
}) {
  return (
    <NumberInput
      value={numberVal}
      onChange={(_valString, valAsNumber) => setNumberVal(valAsNumber)}
      min={minVal}
      max={maxVal}
    >
      <NumberInputField />
      <NumberInputStepper>
        <NumberIncrementStepper />
        <NumberDecrementStepper />
      </NumberInputStepper>
    </NumberInput>
  );
}

AbsoluteIntInput.defaultProps = {
  minVal: Number.MIN_SAFE_INTEGER,
  maxVal: Number.MAX_SAFE_INTEGER,
};
